import { DEFAULT_LANGUAGE } from '@cibli/shared';
import { useTranslation } from 'react-i18next';

import MainLayout from '@/features/common/components/MainLayout';

import TranslateDots from '../components/animations/TranslateDots';

function getLanguageCode(lang?: string): string {
  if (!lang) return getLanguageCode(DEFAULT_LANGUAGE);
  if (lang.includes('-')) return lang.split('-')[1].toUpperCase();
  return lang.toUpperCase();
}

export default function CVTranslatingScreen() {
  const { t, i18n } = useTranslation();

  const sourceLang = getLanguageCode(i18n.language);
  const targetLang = getLanguageCode(DEFAULT_LANGUAGE);

  return (
    <MainLayout>
      <div className="flex flex-1 flex-col items-center justify-center gap-6">
        <div className="flex items-center gap-6">
          <div className="w-14 h-14 rounded-xl bg-[#bad6fc] flex items-center justify-center font-bold text-lg text-[#254441]">
            {sourceLang}
          </div>
          <TranslateDots />
          <div className="w-14 h-14 rounded-xl bg-[#d1f7e3] flex items-center justify-center font-bold text-lg text-[#254441]">
            {targetLang}
          </div>
        </div>
        <div className="text-center">
          <h1 className="text-5xl font-black uppercase tracking-wide">
            {t('Interview.Translating.title')}
          </h1>
          <p className="text-xl text-gray-500 mt-1">{t('Interview.Translating.subtitle')}</p>
        </div>
      </div>
    </MainLayout>
  );
}
